const DEFAULT_CONFIG = {
  centrifugeHost: 'ws.belkapost.ru',
  lkFront: 'lk.belkapost.ru',
};

export default function getAppConfig(): AppConfig {
  return window.appConfig ?? DEFAULT_CONFIG;
}
